(function (upp) {
    'use strict';

    upp.service('productsCategoriesService', ['appi',
        function (appi) {
            var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE + "eshop/categories",
                _get = appi.http.get;

            /**
             * List categories of first level (parents)
             *
             * @method listParents
             * @return {Promise} Returns a promise that will be fullfilled(Array of objects of categories) or rejected
             */
            var listParents = function () {
                return _get(URL_API_REST_SERVER);
            };

            /**
             * List categories of second level (subcategories) filter by the parent category
             *
             * @method listChildrenOfParent
             * @param {String} parentId
             * @return {Promise} Returns a promise that will be fullfilled(Array of objects of categories) or rejected
             */
            var listChildrenOfParent = function (parentId) {
                if (parentId) {
                    return _get(URL_API_REST_SERVER + '?id=' + parentId);
                } else {
                    throw new Error('parentId not indicated');
                }
            };

            return{
                listParents: listParents,
                listChildrenOfParent: listChildrenOfParent
            };
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/plugins/products/services/products-categories-service.js